import { render, staticRenderFns } from "./CompanySubscribers.vue?vue&type=template&id=6d6bdbe5&scoped=true"
import script from "./CompanySubscribers.vue?vue&type=script&lang=ts"
export * from "./CompanySubscribers.vue?vue&type=script&lang=ts"
import style0 from "./CompanySubscribers.vue?vue&type=style&index=0&id=6d6bdbe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bdbe5",
  null
  
)

export default component.exports